/* eslint-disable react-hooks/exhaustive-deps */
import HeadTag from "Components/common/HeadTag";
import JumpBallLoader from "Components/common/JumpBallLoader";
import { observer } from "mobx-react";
import DashboardModule from "Pages/Dashboard/DashboardModule";
import SignupSuccessPage from "Pages/Dashboard/SignupSuccessPage";
import TeamInvite from "Pages/Dashboard/team/TeamInvite";
import TeamInviteAcceptSuccess from "Pages/Dashboard/team/TeamInviteAcceptSuccess";
import LoggedInDealify from "Pages/Register/Dealify/LoggedInDealify";
import { emailVerificationLoggedInState } from "Pages/Register/EmailVerificationLoggedIn";
import RegisterModule from "Pages/Register/RegisterModule";
import UnsubscribePage from "Pages/Unsubscribe/UnsubscribePage";
import UnsubscribeSuccess from "Pages/Unsubscribe/UnsubscribeSuccess";
import Authenticate from "Pages/WhiteLabel/SalesIntel/Authenticate";
import React, { useEffect, useState } from "react";
import {
  Redirect,
  Route,
  Switch,
  useHistory,
  useLocation,
  withRouter
} from "react-router-dom";
import ConnectAppsRouting from "Routes/ConnectApps";
import {
  MP_EVENT,
  TRACKING_KEY,
  WEBSITE_TRACKING_ENV,
  WEBSITE_URL
} from "static/constant";
import PricingStore from "Stores/Pricing";
import { userDetail } from "Stores/userDetail";
import makeApi, { URLS } from "Utils/apiURL";
import {
  checkTeamStatus,
  createFreePlan,
  getFeatureFlagWithTeam,
  loginValidate
} from "Utils/commonAPI";
import { Utils } from "Utils/utils";
import { UNAUTH_REDIRECT_URL } from "../../static/constant";
import { ThemeProvider } from "../contexts/ThemeContext";
import DialerServiceData from "../Stores/DialerServiceStore";

const Routes = (props = {}) => {
  const history = useHistory();
  let isAutoLogin = false;
  let location = useLocation();
  let url = Utils.checkLocationPathname(location.pathname, "/teamInvite/");
  const userData = {};
  let queryParams = Utils.getQueryParams(location.search);
  const activationCode = queryParams.get("key");
  const memberId = queryParams.get("id");
  let pluginUser = queryParams?.get("source")?.includes("plugin");
  pluginUser && localStorage.setItem("isPluginUser", true);
  let homeRouteUser = queryParams?.get("source")?.includes("homepage");

  const [isLoggedIn, setIsLoggedIn] = useState("");

  const loginCheck = async redirectUrl => {
    let res = await loginValidate();
    if (homeRouteUser) {
      redirectUrl = "/pricing";
    }
    if (res) {
      setIsLoggedIn(userDetail.userInfo.userLoggedIn);
      redirectUrl && history.push(redirectUrl);
    } else {
      setIsLoggedIn(false);
      const publicRoutes = ["/unsubscribe", "/pricing", "/teamInvite", "/verify/captcha", "/authenticate", "/access"];
      const isPublicRoute = publicRoutes.some(route => location.pathname.startsWith(route));
      if (!isPublicRoute && location.pathname !== "/login" && location.pathname !== "/signup") {
        history.push("/login");
      }
    }
  };

  const makeAutoLoginApi = async () => {
    let queryParams = Utils.getQueryParams(location?.search);
    let autoLoginKey = queryParams.get("ak") || false;
    let redirectUrl = queryParams.get("redirectUrl") || false;
    if (autoLoginKey) {
      const config = {
        url: URLS.loginUser,
        data: { ak: autoLoginKey },
        method: "POST"
      };
      let response = await makeApi(config);
      if (response?.data?.success) {
        await loginCheck(
          (autoLoginKey &&
            redirectUrl === "connectInbox" &&
            "/settings/account") ||
          location?.pathname ||
          ""
        );
      }
    }
  };

  const checkForAutoLogin = async () => {
    isAutoLogin =
      location?.search.includes("?ak=") ||
      location?.search?.includes("&ak=") ||
      false;
    if (isAutoLogin) {
      makeAutoLoginApi();
    }
  };

  const handleUnsubscribeRedirection = props => {
    const url = props?.match?.url;
    if (url && url.indexOf("/success") !== -1) {
      return <UnsubscribeSuccess />;
    } else {
      const unsubId = url?.split("/unsubscribe/").pop();
      return <UnsubscribePage id={unsubId} />;
    }
  };

  const getDefaultUserCountry = async () => {
    const config = {
      url: URLS.getIpInfo,
      method: "GET"
    };
    const response = await makeApi(config, undefined, false);
    const { data: { country = "" } = {} } = response || {};
    userDetail.setDefaultUserCountry(country?.toLowerCase());
    localStorage.setItem("userDefaultCountry", country?.toLowerCase());
  };

  const createTeam = async data => {
    const config = {
      url: URLS.initializeTeam,
      method: "POST"
    };
    let res = await makeApi(config);
    const userEmail = data?.businessEmail || data?.email;
    Utils.mixpanelTrack(MP_EVENT.TEAM_CREATED, {
      userEmail,
      source:
        localStorage.getItem("isPluginUser") || pluginUser
          ? "PLUGIN"
          : "web-direct",
      phonenumber: data?.phone
    });
    if (res?.data?.teamMember) {
      Utils.mixpanelTrack(MP_EVENT.TEAM_HAS_MEMBER, {
        userEmail,
        source:
          localStorage.getItem("isPluginUser") || pluginUser
            ? "PLUGIN"
            : "web-direct",
        phonenumber: data?.phone
      });

      const resData = await createFreePlan();
      if ([200, "200"].includes(resData?.data?.statusCode)) {
        Utils.mixpanelTrack(MP_EVENT.FREEPLAN_STARTED, {
          userEmail,
          source:
            localStorage.getItem("isPluginUser") || pluginUser
              ? "PLUGIN"
              : "web-direct",
          phonenumber: data?.phone
        });
        userDetail.setUserFeatureFlag(await getFeatureFlagWithTeam());
        userData.team = await checkTeamStatus();
        userDetail.setIsTeamCreated(true);
        userData.email = userEmail?.trim()?.toLowerCase() || "";
        userData.userLoggedIn = true;
        userDetail.setUserInfo(userData);
      } else {
        Utils.mixpanelTrack(MP_EVENT.FREEPLAN_INITIATION_FAILED, {
          userEmail,
          source:
            localStorage.getItem("isPluginUser") || pluginUser
              ? "PLUGIN"
              : "web-direct",
          phonenumber: data?.phone,
          resData: JSON.stringify(resData)
        });
      }
    } else {
      Utils.mixpanelTrack(MP_EVENT.TEAM_FAILED, {
        userEmail,
        source:
          localStorage.getItem("isPluginUser") || pluginUser
            ? "PLUGIN"
            : "web-direct",
        phonenumber: data?.phone
      });
    }
  };

  const constructProfileData = async () => {
    const {
      hasTeam = false,
      email = "",
      firstName = "",
      status = 0,
      phone = ""
    } = userDetail?.userInfo;

    if (status === 2) {
      emailVerificationLoggedInState.setShowPopup(true);
    } else {
      if (!hasTeam) {
        const data = {
          businessEmail: email?.trim()?.toLowerCase(),
          phoneNumber: phone,
          firstName
        };

        // await createTeam(data);
      } else {
        userDetail.setIsTeamCreated(true);
      }
    }
  };

  const activateUser = async () => {
    try {
      const userData = {};
      const homeRouteUser = queryParams?.get("source")?.includes("homepage");
      const config = {
        url: URLS.activateUser ? URLS.activateUser : "",
        method: "POST",
        data: {
          activateKey: activationCode,
          memberId: memberId
        }
      };
      let res = await makeApi(config);
      const { isLoggedIn = false, status = "" } = res?.data || {};
      if (res?.data) {
        switch (status) {
          case "success":
            userData.userLoggedIn = isLoggedIn;
            userDetail.setUserInfo(userData);
            if (homeRouteUser) {
              history.push("/pricing");
            }
            break;
          default:
            history.push(isLoggedIn ? "/dashboard" : "/login");
            break;
        }
      } else {
        history.push("/login");
      }
    } catch (err) {
      console.error(err, "Activate user failed");
    }
  };

  const initializeLogin = async () => {
    await activateUser();
    await loginCheck();
  };

  useEffect(() => {
    if (memberId && activationCode) {
      initializeLogin();
    } else {
      !isAutoLogin && loginCheck();
    }
    checkForAutoLogin();
    const userDefaultCountry = localStorage.getItem("userDefaultCountry");
    Utils.checkTeamUrl(url, location.pathname);
    // Pricing Table
    PricingStore.getActivePlanDetails();
    PricingStore.getDataOutreachPlans();
    !userDefaultCountry
      ? getDefaultUserCountry()
      : userDetail.setDefaultUserCountry(userDefaultCountry);
    if (window && window.sg) {
      var sg = window.sg;
      WEBSITE_TRACKING_ENV === "prod"
        ? sg.init(TRACKING_KEY)
        : sg.init(TRACKING_KEY, "staging");
    }
  }, []);

  useEffect(() => {
    url && Utils.checkTeamUrl(url, location.pathname);
  }, [location]);

  useEffect(() => {
    let loggedUser = userDetail?.userInfo?.userLoggedIn;
    setIsLoggedIn(loggedUser);
    if (
      loggedUser === false &&
      Utils.checkLocationPathname(location?.pathname, "/pricing")
    ) {
      window.open(`${WEBSITE_URL}/pricing`, "_self", "noopener");
    }
    if (loggedUser && userDetail?.userFeatureFlag?.dialerEnabled) {
      DialerServiceData.getDialerPhoneList(false);
    }
  }, [userDetail?.userInfo?.userLoggedIn]);

  useEffect(() => {
    if (
      userDetail.userInfo.userLoggedIn &&
      userDetail?.userInfo?.hasTeam !== null
    ) {
      constructProfileData();
    }
  }, [userDetail.userInfo.hasTeam]);

  useEffect(() => {
    const user = userDetail.userInfo;

    if (isLoggedIn && user && user.email) {
      const fName = user.firstName || "";
      const lName = user.lastName || "";

      window._hsq = window._hsq || [];
      window._hsq.push([
        "identify",
        {
          email: user.email,
          firstname: fName,
          lastname: lName
        }
      ]);
      window._hsq.push(["trackPageView"]);
    }
  }, [isLoggedIn, userDetail.userInfo]);

  const isSalesIntelHost = () =>
    window.location.hostname === "prospectconnect.qa.salesintel.io" ||
    window.location.hostname === "prospectconnect.salesintel.io" ||
    window.location.hostname === "localhost";

  return (
    <>
      <HeadTag pathname={location?.pathname || ""} />

      {isLoggedIn === true ? (
        <ThemeProvider>
          <Switch>
            <Route path="/authenticate" component={Authenticate} />
            <Route path="/access" component={Authenticate} />
            <Route path="/dealify-signup" render={() => <LoggedInDealify />} />
            <Route path="/connect" component={ConnectAppsRouting} />
            <Route
              path="/unsubscribe*"
              render={props => {
                return handleUnsubscribeRedirection(props);
              }}
            />
            <Route
              path="/teamInvite/success"
              exact
              render={() => <TeamInviteAcceptSuccess />}
            />
            <Route path="/teamInvite/:id" exact render={() => <TeamInvite />} />
            <Route path="/signupSuccess" component={SignupSuccessPage} />
            <Route path="/" render={() => <DashboardModule />} />
          </Switch>
        </ThemeProvider>
      ) : isLoggedIn === false ? (
        <Switch>
          <Route path="/authenticate" component={Authenticate} />
          <Route path="/access" component={Authenticate} />
          <Route path="/pricing" component={JumpBallLoader} />
          <Route path="/connect" component={ConnectAppsRouting} />
          <Route
            path="/unsubscribe*"
            render={props => {
              return handleUnsubscribeRedirection(props);
            }}
          />
          {isSalesIntelHost() && (
            <>
              <Route
                path="/login"
                render={() => {
                  window.location.href = UNAUTH_REDIRECT_URL;
                  return null;
                }}
              />
              <Route
                path="/signup"
                render={() => {
                  window.location.href = UNAUTH_REDIRECT_URL;
                  return null;
                }}
              />
            </>
          )}
          <Route
            path="/"
            render={() => <RegisterModule fn={setIsLoggedIn} />}
          />
          <Redirect from="/" to="/" />
        </Switch>
      ) : (
        <JumpBallLoader />
      )}
    </>
  );
};

export default withRouter(observer(Routes));
